import styled from 'styled-components'

const stepTextColor = p => {
    if (p.$active) return '#1d4ed8'
    if (p.$done) return '#047857'
    return '#6b7280'
}

const stepCircleBg = p => {
    if (p.$active) return '#2563eb'
    if (p.$done) return '#10b981'
    return '#e5e7eb'
}

const stepCircleColor = p => {
    if (p.$active || p.$done) return '#fff'
    return '#6b7280'
}

const previewBorderColor = p => (p.$changed ? '#f59e0b' : '#e1e6ef')

const previewBackground = p => (p.$changed ? '#fffbeb' : '#fff')

const previewOpacity = p => (p.$skipped ? 0.45 : 1)

const validationBackground = p => (p.$ok ? '#ecfdf5' : '#fff7ed')

const validationBorder = p => (p.$ok ? '#6ee7b7' : '#fdba74')

const validationColor = p => (p.$ok ? '#065f46' : '#9a3412')

export const EntryStepper = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 18px;
    background: #fff;
    border: 1px solid #e1e6ef;
    border-radius: 8px;
    padding: 12px 16px;
    flex-wrap: wrap;

    @media (max-width: 930px) {
        flex-direction: column;
        align-items: stretch;
        gap: 10px;
    }
`

export const EntryStep = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: ${stepTextColor};
    font-weight: ${p => (p.$active ? 600 : 400)};

    .n {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background: ${stepCircleBg};
        color: ${stepCircleColor};
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 700;
        font-size: 12px;
        flex-shrink: 0;
    }
`

export const EntryStepSep = styled.div`
    flex: 1;
    height: 2px;
    background: #e5e7eb;
    min-width: 20px;

    @media (max-width: 930px) {
        display: none;
    }
`

export const SwitchRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 14px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    margin-bottom: 8px;

    .label {
        font-size: 13.5px;
        color: #1f2933;

        b {
            color: #1d4ed8;
        }

        .hint-inline {
            color: #92400e;
            font-weight: 600;
            font-size: 12px;
        }
    }
`

export const ToggleSwitch = styled.button`
    position: relative;
    width: 38px;
    height: 22px;
    background: ${p => (p.$on ? '#2563eb' : '#cbd5e1')};
    border: none;
    border-radius: 11px;
    cursor: pointer;
    flex-shrink: 0;
    padding: 0;

    &::after {
        content: '';
        position: absolute;
        top: 2px;
        left: ${p => (p.$on ? '18px' : '2px')};
        width: 18px;
        height: 18px;
        background: #fff;
        border-radius: 50%;
        transition: left 0.15s;
    }
`

export const WeekGridWrap = styled.div`
    border: 1px solid #e1e6ef;
    border-radius: 8px;
    overflow: visible;
    position: relative;

    table {
        width: 100%;
        border-collapse: collapse;
        font-size: 13px;
        table-layout: fixed;
    }

    col.wk-col-week {
        width: 104px;
    }

    col.wk-col-date {
        width: 168px;
    }

    col.wk-col-dropdown {
        width: auto;
    }

    col.wk-col-quick {
        width: 112px;
    }

    th {
        background: #f1f5f9;
        color: #1f2933;
        text-align: left;
        padding: 10px 12px;
        font-size: 12px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.4px;
        border-bottom: 1px solid #e1e6ef;
    }

    td {
        padding: 10px 12px;
        border-bottom: 1px solid #f1f5f9;
        vertical-align: middle;
    }

    tr:last-child td {
        border-bottom: none;
    }

    tr.skipped td {
        opacity: 0.45;
        text-decoration: line-through;
    }

    th.wk-col-week,
    td.wk-col-week {
        width: 104px;
        padding-right: 8px;
    }

    th.wk-col-date,
    td.wk-col-date {
        width: 168px;
        padding-left: 4px;
        padding-right: 16px;
    }

    th.wk-col-dropdown,
    td.wk-col-dropdown {
        width: auto;
        min-width: 0;
    }

    th.wk-quick-fill,
    td.wk-quick-fill {
        text-align: right;
        width: 112px;
        padding-left: 8px;
    }

    .ui.dropdown.wk-grid-dropdown {
        width: 100% !important;
        min-width: unset !important;
        max-width: 100% !important;
        margin: 0 !important;
    }

    .ui.dropdown.wk-grid-dropdown.active,
    .ui.dropdown.wk-grid-dropdown.visible {
        z-index: 2000;
    }

    .ui.dropdown.wk-grid-dropdown .menu {
        z-index: 2001 !important;
        max-height: 200px;
        overflow-y: auto !important;
        border: 1px solid rgba(34, 36, 38, 0.15) !important;
        box-shadow:
            0 2px 4px 0 rgba(34, 36, 38, 0.12),
            0 2px 10px 0 rgba(34, 36, 38, 0.08) !important;
    }

    .ui.dropdown.wk-grid-dropdown .menu > .item {
        word-wrap: break-word !important;
    }

    @media (max-width: 930px) {
        border-radius: 10px;

        thead,
        colgroup {
            display: none;
        }

        table,
        tbody {
            display: block;
            width: 100%;
        }

        tr.wk-mobile-row {
            display: block;
            padding: 14px 16px;
            border-bottom: 1px solid #e1e6ef;
            background: #fff;
        }

        tr.wk-mobile-row:last-child {
            border-bottom: none;
        }

        td {
            display: block;
            width: 100% !important;
            padding: 0 !important;
            border-bottom: none !important;
        }

        td.wk-col-week {
            margin-bottom: 4px;
            padding-top: 0 !important;
        }

        td.wk-col-date {
            margin-bottom: 12px;
            font-size: 12.5px !important;
            color: #475569 !important;
            font-weight: 500 !important;
        }

        td.wk-col-dropdown {
            margin-bottom: 12px;
        }

        td.wk-col-dropdown-workplace::before {
            content: 'Workplace';
            display: block;
            font-size: 10px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.4px;
            color: #6b7a9e;
            margin-bottom: 6px;
        }

        td.wk-col-dropdown-template::before {
            content: 'Templates';
            display: block;
            font-size: 10px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.4px;
            color: #6b7a9e;
            margin-bottom: 6px;
        }

        td.wk-quick-fill {
            text-align: left;
            margin-top: 4px;
        }

        td.wk-quick-fill::before {
            content: 'Quick fill';
            display: block;
            font-size: 10px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.4px;
            color: #6b7a9e;
            margin-bottom: 6px;
        }
    }
`

export const WeekDropdownCell = styled.div`
    position: relative;
    width: 100%;
    min-width: 0;

    .ui.dropdown.wk-grid-dropdown {
        width: 100% !important;
        min-width: 0 !important;
        max-width: 100% !important;
    }

    ${p =>
        p.$changed
            ? `
        .ui.dropdown.wk-grid-dropdown > .text,
        .ui.dropdown.wk-grid-dropdown > .default.text {
            padding-right: 52px;
        }
    `
            : ''}
`

export const WkDropdownCol = styled.td`
    min-width: 0;
    padding-top: 8px !important;
    padding-bottom: 8px !important;
`

export const QuickFillCell = styled.td`
    white-space: nowrap;
    vertical-align: middle !important;
    text-align: right;
`

export const QuickFillActions = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 4px;
`

export const WkNum = styled.td`
    font-weight: 700;
    color: #1d4ed8 !important;
    vertical-align: top !important;
    padding-top: 12px !important;

    .wk-label {
        display: block;
        line-height: 1.3;
    }
`

export const WkDate = styled.td`
    color: #475569 !important;
    font-size: 12.5px !important;
`

export const PartialBadge = styled.span`
    display: block;
    width: fit-content;
    background: #fef3c7;
    color: #92400e;
    padding: 1px 6px;
    border-radius: 3px;
    font-size: 10.5px;
    font-weight: 600;
    margin-top: 4px;
    line-height: 1.3;
`

export const ChangeFlag = styled.span`
    position: absolute;
    right: 30px;
    top: 50%;
    transform: translateY(-50%);
    background: #fef3c7;
    color: #92400e;
    padding: 1px 5px;
    border-radius: 3px;
    font-size: 10px;
    font-weight: 600;
    line-height: 1.2;
    white-space: nowrap;
    pointer-events: none;
    z-index: 1;
`

export const CopyBtn = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 28px;
    background: none;
    border: 1px solid #cbd2dc;
    border-radius: 4px;
    padding: 4px 8px;
    font-size: 11px;
    color: #475569;
    cursor: pointer;
    white-space: nowrap;
    line-height: 1.2;

    &:hover {
        background: #f1f5f9;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`

export const QuickActions = styled.div`
    display: flex;
    gap: 8px;
    padding: 10px 12px;
    background: #f8fafc;
    border-top: 1px solid #e1e6ef;
    flex-wrap: wrap;
    align-items: center;
    border-radius: 0 0 8px 8px;

    .toolbar-actions {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        align-items: center;
    }

    button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-height: 32px;
        line-height: 1.2;
        background: #fff;
        border: 1px solid #cbd2dc;
        color: #1d4ed8;
        padding: 6px 12px;
        border-radius: 5px;
        font-size: 12.5px;
        cursor: pointer;
        font-weight: 500;
        white-space: nowrap;
        vertical-align: middle;

        &:hover {
            background: #eff6ff;
            border-color: #2563eb;
        }
    }

    .quick-tip {
        margin-left: auto;
        font-size: 12px;
        color: #6b7280;
        line-height: 1.4;
        align-self: center;
    }

    @media (max-width: 930px) {
        flex-direction: column;
        align-items: stretch;

        .toolbar-actions {
            flex-direction: column;
            width: 100%;

            button {
                width: 100%;
            }
        }

        .quick-tip {
            margin-left: 0;
            margin-top: 4px;
        }
    }
`

export const CustomRangeForm = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: flex-end;
    padding: 12px;
    background: #fff;
    border-top: 1px dashed #e1e6ef;

    label {
        display: flex;
        flex-direction: column;
        gap: 4px;
        font-size: 12px;
        font-weight: 600;
        color: #475569;
    }

    input {
        padding: 6px 10px;
        border: 1px solid #cbd2dc;
        border-radius: 5px;
        font-size: 13px;
    }

    button {
        background: #fff;
        border: 1px solid #cbd2dc;
        color: #1d4ed8;
        padding: 6px 12px;
        border-radius: 5px;
        font-size: 12.5px;
        cursor: pointer;
        font-weight: 500;
        height: 34px;

        &:hover {
            background: #eff6ff;
            border-color: #2563eb;
        }
    }
`

export const PreviewStrip = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
    gap: 6px;
    margin-top: 14px;

    @media (max-width: 930px) {
        grid-template-columns: 1fr;
        gap: 10px;
    }
`

export const PreviewWk = styled.div`
    border: 1px solid ${previewBorderColor};
    border-radius: 6px;
    padding: 8px 10px;
    text-align: center;
    background: ${previewBackground};
    opacity: ${previewOpacity};

    @media (max-width: 930px) {
        text-align: left;
        padding: 12px 14px;
        border-radius: 8px;
    }

    .pw-label {
        font-size: 11px;
        color: #6b7280;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.3px;
    }

    .pw-loc {
        font-size: 13px;
        font-weight: 700;
        color: #1f2933;
        margin-top: 4px;
    }

    .pw-tpl {
        font-size: 11px;
        color: #6b7280;
        margin-top: 2px;
    }
`

export const ValidationStrip = styled.div`
    background: ${validationBackground};
    border: 1px solid ${validationBorder};
    border-radius: 6px;
    padding: 10px 14px;
    margin-bottom: 12px;
    font-size: 13px;
    color: ${validationColor};
`

export const SaveBtnRow = styled.div`
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    padding-top: 14px;
    border-top: 1px solid #e1e6ef;
    margin-top: 16px;
    flex-wrap: wrap;

    @media (max-width: 930px) {
        flex-direction: column-reverse;
        align-items: stretch;

        button {
            width: 100%;
        }
    }
`

export const BtnPrimary = styled.button`
    padding: 9px 18px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    border: none;
    background: #2563eb;
    color: #fff;

    &:hover {
        background: #1d4ed8;
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`

export const BtnSecondary = styled.button`
    padding: 9px 18px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    background: #fff;
    color: #475569;
    border: 1px solid #cbd2dc;

    &:hover {
        background: #f8fafc;
    }
`

export const BtnGhost = styled(BtnSecondary)`
    background: transparent;
    color: #6b7280;
    border-color: #e2e8f0;
`
